export default "__VITE_ASSET__Cf_5ksoc__"